import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=887828b4&scoped=true&"
import script from "./HeaderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=887828b4&prod&lang=scss&scoped=true&"
import style1 from "./HeaderComponent.vue?vue&type=style&index=1&id=887828b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887828b4",
  null
  
)

export default component.exports